import './App.css';
import {ConfigProvider} from 'antd';
import Aos from 'aos';
import {jwtDecode} from 'jwt-decode';
import {useEffect, useState} from 'react';
import {Toaster} from 'react-hot-toast';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Routes} from 'react-router-dom';

import 'aos/dist/aos.css';
import {ProtectedRoute} from './commonComponents/ProtectedRoutes';
import JsonData from './data/data.json';
import {logoutStart} from './redux/authAction';
import {selectAuth} from './redux/selectors';
import {AboutUsScreen} from './screenComponent/AboutUsScreen';
import {AdminDashboard} from './screenComponent/AdminDashboard';
import {CartScreen} from './screenComponent/CartScreen';
import {CheckOutScreen} from './screenComponent/CheckOutScreen';
import ContactUsForm from './screenComponent/ContactUsComponent/ContactUsForm';
import {GalleryScreen} from './screenComponent/GalleryScreen';
import {GoldScreen} from './screenComponent/GoldScreen';
import {HomeScreen} from './screenComponent/HomeScreen';
import {LayoutComponent} from './screenComponent/LayoutComponent';
import {LoginScreen} from './screenComponent/LoginScreen';
import AuthLayout from './screenComponent/LoginScreen/AuthLayout';
import {RegistrationScreen} from './screenComponent/LoginScreen/RegistrationScreen';
import {ProductDetails} from './screenComponent/ProductDetails';
import {ProductScreen} from './screenComponent/ProductScreen';
import {ScrollToTop} from './screenComponent/ScrollToTop';
import {TermsAndCondition} from './screenComponent/TermsAndCondition';
import {UserHistory} from './screenComponent/UserHistory';

function App() {
  useEffect(() => {
    Aos.init({duration: 1500, once: true});
  }, []);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const dispatch = useDispatch();

  const {loggedIn} = useSelector(state => state.auth);

  const [websiteData, setWebsiteData] = useState({});

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);

      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp < currentTime && loggedIn) {
        dispatch(logoutStart());
      }
    } else if (loggedIn) {
      dispatch(logoutStart());
    }
  }, [token, loggedIn, dispatch]);

  useEffect(() => {
    setWebsiteData(JsonData);
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#502f27',
        },
      }}
    >
      <div>
        <ScrollToTop />
        <Toaster />
        <Routes>
          <Route path={'/auth'} element={<AuthLayout />}>
            <Route path={'login'} element={<LoginScreen />} />
            <Route path={'register'} element={<RegistrationScreen />} />
          </Route>
          <Route path={'/'} element={<LayoutComponent />}>
            <Route index element={<HomeScreen />} />
            <Route path={'product'} element={<ProductScreen />} />
            <Route path={'/about'} element={<AboutUsScreen />} />
            <Route path={'/contact'} element={<ContactUsForm />} />
            <Route path={'/product/:id'} element={<ProductDetails />} />
            <Route path={'/cart'} element={<CartScreen />} />
            <Route path={'/gold'} element={<GoldScreen />} />
            <Route path={'/terms'} element={<TermsAndCondition data={JsonData.TermsAndConditions} />} />
            <Route path={'/checkout'} element={<CheckOutScreen />} />
            <Route path={'/gallery'} element={<GalleryScreen data={JsonData.Gallery} />} />
            <Route path={'/userhistory'} element={<UserHistory />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
            <Route path={'/*'} element={<AdminDashboard />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;
